export const activityFilters = [
  'All',
  'Label Print',
  'Sync',
];

export const dateFilters = [
  'Choose Dates',
];

export const resolveReasons = [
  'User Error',
  'Resolved In Oracle EBS',
  'Duplicate Transaction',
  'Other',
];

export const statusFilters = [
  'All',
  'Success',
  'Failed',
  'Pending',
  'Processing',
  'Resolved',
  'Submitted',
];

/* export const packSiteMapping = {
  'WM Morrisons Produce': ['CH1', 'FL1', 'TH1', 'RD1', 'GB1'],
  'Woodheads': ['CL1', 'SP1', 'TR1', 'CLN', 'SPL', 'TRF'],
  'Rathbones': ['WF1'],
  'International Seafoods': ['GY2'],
  'Simply Fresh': ['WS1'],
  'Farmers Boy': ['WN1', 'GS1', 'DS1'],
}; */

export const supplierIdMapping = {
  'WM Morrisons Produce': ['2725', '8600'],
  'Woodheads': ['28213', '24110', '34516', '2329', '2321', '2325'],
  'Rathbones': ['2745', '2868'],
  'International Seafoods': ['24518', '6994'],
  'Simply Fresh': ['15346', '1217'],
  'Farmers Boy Greenside': ['2639', '2645', '24305', '8803', '8807', '8800'],
  'Farmers Boy Deeside': ['15318', '8811'],
  'Farmers Boy Winsford': ['23028', '0253'],
  'Lowlands': ['23979', '1208'],
  'Flowerworld': ['23974', '0636'],
};

export const SupplierId = {
  'PRD': [
    { displayName: '2725 - Produce', name: 'Produce', supplierId: '2725' },
    { displayName: '8600 - Produce', name: 'Produce', supplierId: '8600' },
  ],
  'WHD': [
    { displayName: '28213 - Colne', name: 'Colne', supplierId: '28213' },
    { displayName: '24110 - Turiff', name: 'Turiff', supplierId: '24110' },
    { displayName: '34516 - Spalding', name: 'Spalding', supplierId: '34516' },
    { displayName: '2329 - Colne', name: 'Colne', supplierId: '2329' },
    { displayName: '2321 - Spalding', name: 'Spalding', supplierId: '2321' },
    { displayName: '2325 - Turiff', name: 'Turiff', supplierId: '2325' },
  ],
  'RBL': [
    { displayName: '2745 - Wakefield', name: 'Wakefield', supplierId: '2745' },
    { displayName: '2868 - Wakefield', name: 'Wakefield', supplierId: '2868' },
  ],
  'ISL': [
    { displayName: '24518 - Lakeside', name: 'Lakeside', supplierId: '24518' },
    { displayName: '6994 - Lakeside', name: 'Lakeside', supplierId: '6994' },
  ],
  'SFL': [
    { displayName: '15346 - Worsley', name: 'Worsley', supplierId: '15346' },
    { displayName: '1217 - Worsley', name: 'Worsley', supplierId: '1217' },
  ],
  'FBG': [
    { displayName: '2639 - Greenside', name: 'Greenside', supplierId: '2639' },
    { displayName: '2645 - Greenside', name: 'Greenside', supplierId: '2645' },
    { displayName: '24305 - Greenside', name: 'Greenside', supplierId: '24305' },
    { displayName: '8803 - Greenside', name: 'Greenside', supplierId: '8803' },
    { displayName: '8807 - Greenside', name: 'Greenside', supplierId: '8807' },
    { displayName: '8800 - Greenside', name: 'Greenside', supplierId: '8800' },
  ],
  'FBD': [
    { displayName: '15318 - Deeside', name: 'Deeside', supplierId: '15318' },
    { displayName: '8811 - Deeside', name: 'Deeside', supplierId: '8811' },
  ],
  'FBW': [
    { displayName: '23028 - Winsford', name: 'Winsford', supplierId: '23028' },
    { displayName: '0253 - Winsford', name: 'Winsford', supplierId: '0253' },
  ],
  'LLN': [
    { displayName: '23979 - Lowlands', name: 'Lowlands', supplierId: '23979' },
    { displayName: '1208 - Lowlands', name: 'Lowlands', supplierId: '1208' },
  ],
  'FLW': [
    { displayName: '23974 - Flowerworld', name: 'Flowerworld', supplierId: '23974' },
    { displayName: '0636 - Flowerworld', name: 'Flowerworld', supplierId: '0636' },
  ],
};

export const WarehouseId = {
  'PRD': [
    { displayName: 'ALL', value: 'CH1,TH1,FL1,GB1,RD1' },
    { displayName: 'CH1', value: 'CH1' },
    { displayName: 'TH1', value: 'TH1' },
    { displayName: 'FL1', value: 'FL1' },
    { displayName: 'GB1', value: 'GB1' },
    { displayName: 'RD1', value: 'RD1' },
  ],
  'WHD': [
    { displayName: 'ALL', value: 'CL1,SP1,TR1,TRF,SPL,CLN' },
    { displayName: 'CL1', value: 'CL1' },
    { displayName: 'SP1', value: 'SP1' },
    { displayName: 'TR1', value: 'TR1' },
    { displayName: 'CLN', value: 'CLN' },
    { displayName: 'SPL', value: 'SPL' },
    { displayName: 'CLN', value: 'CLN' },
  ],
  'RBL': [
    { displayName: 'ALL', value: 'WF1' },
    { displayName: 'WF1', value: 'WF1' },
  ],
  'ISL': [
    { displayName: 'ALL', value: 'GY2' },
    { displayName: 'GY2', value: 'GY2' },
  ],
  'SFL': [
    { displayName: 'ALL', value: 'WS1' },
    { displayName: 'WS1', value: 'WS1' },
  ],
  'FBG': [
    { displayName: 'ALL', value: 'GS1' },
    { displayName: 'GS1', value: 'GS1' },
  ],
  'FBD': [
    { displayName: 'ALL', value: 'DS1' },
    { displayName: 'DS1', value: 'DS1' },
  ],
  'FBW': [
    { displayName: 'ALL', value: 'WN1' },
    { displayName: 'WN1', value: 'WN1' },
  ],
  'LLN': [
    { displayName: 'ALL', value: 'LL1' },
    { displayName: 'LL1', value: 'LL1' },
  ],
  'FLW': [
    { displayName: 'ALL', value: 'FW1' },
    { displayName: 'FW1', value: 'FW1' },
  ],
};

export default SupplierId;